<template>
    <div>
        <ContainerTitle icon="line-chart" title="Relatório de Utilização">
            <div class="d-flex align-items-start justify-content-start gap-2">
                <b-form-group
                    id="empresa"
                    v-if="displaySelectEmpresa"
                    label="Empresa:"
                    label-for="empresa"
                    class="mb-0 form-group-fixed"
                >
                    <InputAutocomplete
                    v-if="!isAdmin"
                    :showId="true"
                    :loader="empresaRelatorioAutocompleteLoader"
                    v-model="empresa"
                    @input="getReport('empresa')"
                    />
                    <InputAutocomplete
                    v-else
                    :showId="true"
                    :loader="empresaAutocompleteLoader"
                    v-model="empresa"
                    @input="getReport('empresa')"
                    />
                </b-form-group>

                <b-form-group
                    id="grupo"
                    v-if="gestorGrp"
                    label="Grupo:"
                    label-for="grupo"
                    class="mb-0 form-group-fixed"
                >
                    <InputAutocomplete
                    :loader="grupoEmpresarialAutocompleteLoader"
                    v-model="group"
                    :showId="true"
                    @input="getReport('group')"
                    />
                </b-form-group>
            </div>
        </ContainerTitle>
        <div class="relatorio">
            <div class="row m-0 w-100">
                <div v-if="displayReport && embedConfig" class="col-12 mt-1">
                    <PowerBIReportEmbed width="100%"
                        :embedConfig="embedConfig"
                        :key="embedConfig.id + '-' + embedConfig.accessToken"
                        :eventHandlers="eventHandlers"
                        cssClassName="report-container"
                    />
                </div>
            </div>

        </div>
    </div>
</template>
<script>

import EmpresaResource from "@/resources/EmpresaResource"
import InputAutocomplete from "@/components/commons/Inputs/InputAutocomplete"
import RelatorioResource from "@/resources/RelatorioResource.js";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import { mapGetters } from "vuex"
import { PowerBIReportEmbed } from 'powerbi-client-vue-js';
import 'powerbi-report-authoring';
import * as powerbi from 'powerbi-client';
window['powerbi-client'] = powerbi;

export default {
    name: 'HistoricoInativacao',
    components: {
        PowerBIReportEmbed,
        InputAutocomplete,
        ContainerTitle
    },
	data() {
		return {
            displayReport: false,
            displaySelectEmpresa: false,
            gestorGrp: false,
            empresa: null,
            group: null,
            embedConfig: null,
            eventHandlers: null,
            reportRef: null
		}
	},  
    computed: {
      ...mapGetters("user", ["authorities"]),
      isAdmin () {
          if ( this.authorities ) {
              return this.authorities.includes("ROLE_ADMIN")
          }   
          return false;
      }
    },
    methods: {
        empresaAutocompleteLoader: EmpresaResource.autocomplete,
        empresaRelatorioAutocompleteLoader : RelatorioResource.empresa,
        grupoEmpresarialAutocompleteLoader : RelatorioResource.grupo,
        onReportLoaded(event) {
            console.log('Report loaded:', event);
        },
        resetFilter() {
            for (let key in this.form)
            {
                this.form[key] = null
            }  
        },
        getReport(type)
		{
            type === 'empresa' ? this.group = null : this.empresa = null;
            const typeReport = this.group ? 'group' : 'company';
            const codCompany = this.group ? this.group.id : this.empresa.id;

			RelatorioResource.post( { typeReport: typeReport, codCompany: codCompany } , {showLoader: true})
			.then(response => {

                this.displayReport = response.displayReport || false
                this.displaySelectEmpresa = response.displaySelectEmpresa || false
                this.gestorGrp = response.gestorGrp || false

                if (response.embedUrl && response.embedToken && response.embedReportId) {
                    this.embedConfig = {
                        type: 'report',
                        tokenType: window['powerbi-client'].models.TokenType.Embed,
                        accessToken: response.embedToken,
                        embedUrl: response.embedUrl,
                        id: response.embedReportId,
                        settings: {
                        //filterPaneEnabled: true,
                       // navContentPaneEnabled: true,
                        background: window['powerbi-client'].models.BackgroundType.Default
                        }
                    };
                }
			})
		},
    },
    mounted() {

        this.eventHandlers = new Map([
            ['loaded', this.onReportLoaded],
            ['rendered', () => console.log('Report rendered')],
            ['error', (event) => console.error('Power BI Error:', event.detail)]
        ]);

        RelatorioResource.get().then(response => {
            this.displayReport = response.displayReport || false
            this.displaySelectEmpresa = response.displaySelectEmpresa || false
            this.gestorGrp = response.gestorGrp || false

        }).catch(error => {
            console.error("Error fetching data:", error);
        });
    }
}

</script>

<style scoped>
.relatorio {
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
	/* padding: 20px 0 20px 5px; */
    background-color: #fff;
    width: 100%;
}

.form-group-fixed {
  min-width: 30vw;
  flex: 1;
  margin-top: -2vh;
}

.report-container {
  width: 100%;
  height: 80vh;
}

.gap-3 > * + * {
  margin-left: 1rem;
}

</style>

<style>
    iframe {
    border: none !important;
    }
</style>